/**
 * The cash a payment brought, when the record supports it and there was change; null otherwise. A payment from
 * before "cash received" was recorded, an exact payment, a non-cash tender, or a record whose figures disagree all
 * give null, so a receipt prints the applied amount alone and never a received figure it cannot vouch for.
 */
export function cashHandedOver(payment) {
    if (payment.tender !== 'cash')
        return null;
    const { amount } = payment;
    const wallet = payment.changeToWallet ?? null;
    if (wallet !== null) {
        if (wallet.amount.currency !== amount.currency || wallet.amount.amount <= 0)
            return null;
        return {
            received: { amount: amount.amount + wallet.amount.amount, currency: amount.currency },
            change: wallet.amount,
            toWallet: true,
            playerName: wallet.playerName ?? null,
        };
    }
    const tendered = payment.tendered ?? null;
    if (tendered === null || tendered.currency !== amount.currency || tendered.amount < amount.amount)
        return null;
    const change = tendered.amount - amount.amount;
    const recorded = payment.change ?? null;
    if (recorded !== null && (recorded.currency !== amount.currency || recorded.amount !== change))
        return null;
    if (change === 0)
        return null;
    return { received: tendered, change: { amount: change, currency: amount.currency }, toWallet: false, playerName: null };
}
/**
 * The tender rows of a receipt, in payment order. A sale paid by one cash payment with change shows what was
 * received and the change (what it applied is the Total above); any other payment shows its applied amount, and a
 * cash one with change adds the received amount and the change under it. A payment with no recorded hand-over shows
 * its applied amount alone.
 */
export function receiptTenderRows(payments, total) {
    const only = payments.length === 1 ? payments[0] : undefined;
    const single = only !== undefined && only.amount.amount === total.amount && only.amount.currency === total.currency;
    const rows = [];
    for (const payment of payments) {
        const hand = cashHandedOver(payment);
        const nested = !single;
        if (nested || hand === null)
            rows.push({ kind: 'tender', tender: payment.tender, amount: payment.amount });
        if (hand === null)
            continue;
        rows.push({ kind: 'cash_received', amount: hand.received, nested });
        rows.push(hand.toWallet ? { kind: 'change_to_wallet', amount: hand.change, playerName: hand.playerName, nested } : { kind: 'change', amount: hand.change, nested });
    }
    return rows;
}
//# sourceMappingURL=receipt-tenders.js.map